import { combineReducers } from "redux";
import bots from "./bots";
import filters from "./filters";


export default combineReducers({
    bots,
    filters,
});